import { render } from "./DeviceShowcase.vue?vue&type=template&id=7979eb96&scoped=true"
import script from "./DeviceShowcase.vue?vue&type=script&lang=js"
export * from "./DeviceShowcase.vue?vue&type=script&lang=js"

import "./DeviceShowcase.vue?vue&type=style&index=0&id=7979eb96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7979eb96"]])

export default __exports__